import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    mixins: [emCommonUtilMixin],
    props: {
        filterSwitchAble: {
            type: Boolean,
            default: false
        },
        filterSwitchInHeader: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            configChangeFlag: 0
        }
    },
    computed: {
        currentFilterConfig() {
            if (this.configChangeFlag || this.changeFlag) {
                //
            }
            if (this.checkedFilterMap.size > 0 || this.openSortFilter.size > 0 || this.groupingField || this.sortBy) {
                return {
                    checkedFilterMap: [...this.checkedFilterMap.entries()].reduce((obj, [key, value]) => (obj[key] = Array.from(value), obj), {}),
                    openSortFilter: Array.from(this.openSortFilter),
                    groupingField: this.groupingField,
                    groupWay: this.groupWay,
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc
                };
            }
            return null;
        },
    },
    methods: {
        gatherConfig() {
            return this.currentFilterConfig;
        },
        unpackConfig(item) {
            if (item == null) {
                this.checkedFilterMap = new Map();
                this.openSortFilter = new Set();
                this.groupingField = null;
                this.groupWay = null;
                this.groupMap = null;
                this.sortBy = null;
                this.sortDesc = false;
            } else {
                let config = JSON.parse(item.configuration);
                this.openSortFilter = new Set(config.openSortFilter);
                this.filterMap = new Map();
                this.checkedFilterMap = new Map();
                let map = config.checkedFilterMap;

                this.$nextTick(() => {
                    for (let field of this.fieldList) {
                        let col = field.key;
                        let refEl = this.getRefEl('RFD_' + col);
                        if (refEl) {
                            if (map && map.hasOwnProperty(col)) {
                                refEl.recoverFilterByChecked(new Set(map[col]));
                            } else {
                                refEl.recoverFilterByChecked(null);
                            }
                        }
                    }
                });
                this.groupingField = config.groupingField;
                this.groupWay = config.groupWay;
                if (this.hasCode(this.groupingField)) {
                    this.$nextTick(() => {
                        let refEl = this.getRefEl('RFD_' + this.groupingField);
                        if (refEl) {
                            refEl.dateSplitUnit = this.groupWay;
                        }
                    })
                } else {
                    this.groupMap = null;
                }
                this.sortBy = config.sortBy;
                this.sortDesc = config.sortDesc;
            }
        }
    }
}
